import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import ErrorMessage from '../../../ErrorMessage';
import Loading from '../../../../../components/Loading';
import { gscTestQuery } from '../../../../GSCTestData/query';

class Summary extends Component {
    constructor() {
        super();

        this.addPromps = this.addPromps.bind(this);
        this.getPrompts = this.getPrompts.bind(this);
        this.closeAddKeywordModal = this.closeAddKeywordModal.bind(this);
        this.onOpenAddKeywordModal = this.onOpenAddKeywordModal.bind(this);

        this.state = {
            selectedItems: [],
            tableData: [],
            loading: false,
            didSearch: false,
            isAddKeywordModalOpen: false,
            error: '',
        };
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            if (item.title) return item.title?.toLowerCase().includes(search.toLowerCase());
            return item.page?.toLowerCase().includes(search.toLowerCase());
        });
    }

    onOpenAddKeywordModal = () => {
        this.setState({ isAddKeywordModalOpen: true });
    };

    closeAddKeywordModal = () => {
        this.setState({ isAddKeywordModalOpen: false });
    };

    addPromps() {
        this.onOpenAddKeywordModal();
    }

    componentDidMount() {
        if (this.props.all && (!this.props.data || this.props.data.length === 0)) {
            this.getPrompts();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.all && this.props.selectedDomainId !== prevProps.selectedDomainId) {
            this.getPrompts();
        }
    }

    async getPrompts() {
        try {
            this.setState({ loading: true, error: '' });
            this.props.updateTableData([], true);
            this.props.onSubmit?.();
            const today = moment().format('YYYY-MM-DD');
            const thirtyDays = moment().subtract(30, 'days').format('YYYY-MM-DD');

            const resource = `{
                "startDate": "${thirtyDays}",
                "endDate": "${today}",
                "dimensions": ["query"],
                "rowLimit": 1000,
                ${
                    !this.props.all
                        ? `"dimensionFilterGroups": [
                    {
                    "filters": [
                        {
                        "dimension": "query",
                        "operator": "includingRegex",
                        "expression": ${this.props.expression}
                        }
                    ]
                    }
                ]`
                        : ''
                }
        }`;

            const params = {
                resource: resource,
                domain: this.props.selectedDomain,
            };

            const body = {
                domain_id: this.props.selectedDomainId,
                queries: [
                    {
                        ...params,
                        key: 'data',
                    },
                ],
                max_count: 10000,
            };

            const response = await gscTestQuery(body);

            const data = await response.json();
            if (data.status === 200) {
                const results = data?.results?.data?.map((item, index) => ({
                    id: item.keys?.[0] ?? index,
                    ...item,
                }));
                this.setState({
                    tableData: results || [],
                    didSearch: true,
                });
                this.props.updateTableData(results || [], false, true);
            } else {
                this.props.updateTableData([], false);
                this.setState({
                    tableData: [],
                    error: data.message || 'Something went wrong. Please try again.',
                });
            }
        } catch (err) {
            console.log('err', err);
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { t, all } = this.props;

        return (
            <div className="prompt-generator-google-search-body">
                {!this.props.dontShowHint && (
                    <div className="language-change-warning">
                        {t('ai_tracking.prompt_generator.googleSearchConsole.subtitle')}
                    </div>
                )}
                <div className="input-label">{this.props.inputLabel}</div>
                <div className="prompt-generator-google-search-input-section">
                    {!all && (
                        <>
                            <input
                                name="branded_terms"
                                className="form-control"
                                value={this.props.inputData}
                                onChange={this.props.onChangeInput}
                                disabled={
                                    this.state.loading ||
                                    this.props.inputDisabled ||
                                    this.props.loaderConfigs
                                }
                            />
                            <div>
                                <button
                                    className={'button button-filled button-primary w-100'}
                                    onClick={this.getPrompts}
                                    disabled={(!all && !this.props.inputData) || this.state.loading}
                                >
                                    {this.props.buttonLabel ??
                                        t(
                                            'ai_tracking.prompt_generator.googleSearchConsole.get_questions',
                                        )}
                                </button>
                            </div>
                        </>
                    )}
                </div>
                {this.props.loaderConfigs && (
                    <div className="d-flex align-items-center justify-content-center mt-20 w-100">
                        <Loading />
                    </div>
                )}
                {this.state.error && <ErrorMessage message={this.state.error} />}
            </div>
        );
    }
}
export default withTranslation()(Summary);
